// extracted by mini-css-extract-plugin
module.exports = {"MenuGroup--max-height":"bgp_a"};